// import React, { useEffect, useState } from "react";
// import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
// import {
//   CancelButton,
//   LogButton,
//   SaveButton,
// } from "../../../../components/mui/Buttons/Buttons";
// import {
//   Alert,
//   Box,
//   Chip,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   Stack,
//   TextField,
// } from "@mui/material";
// import { useSnackbar } from "notistack";
// import MotionContainer from "../../../../components/FramerMotion/MotionContainer";
// import { motion } from "framer-motion";
// import OutlinedInput from "@mui/material/OutlinedInput";
// import { Icon } from "@iconify/react";
// import { useSelector } from "react-redux";

// const RemarkPopup = ({
//   item,
//   handleInputChange,
//   handleClose,
//   update,
//   paid,
// }) => {
//   const [open, setOpen] = useState(false);
//   const { classes } = useSelector((state) => state.cro);

//   const ITEM_HEIGHT = 48;
//   const ITEM_PADDING_TOP = 8;
//   const MenuProps = {
//     PaperProps: {
//       style: {
//         maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//         width: 250,
//       },
//     },
//   };
//   const [data, setData] = useState({
//     levelOpted: {
//       target: {
//         value: [],
//       },
//     },
//     booksAndPublication: {
//       target: {
//         value: "",
//       },
//     },
//     preferredChapter: {
//       target: {
//         value: "",
//       },
//     },
//     remarks: {
//       target: {
//         value: "",
//       },
//     },
//     courseLevelStatus: {
//       target: {
//         value: item?.courseLevelStatus,
//       },
//     },
//     currentClass: {
//       target: {
//         value: item?.currentClass,
//       },
//     },
//     subjectsAndSession: {
//       target: {
//         value: item?.subjectsAndSession,
//       },
//     },
//   });

//   const { enqueueSnackbar } = useSnackbar();
//   const names = [
//     "level 1",
//     "level 2",
//     "level 3",
//     "level 4",
//     "level 5",
//     "Basic",
//     "Intermediate",
//     "Advanced",
//   ];
//   const [personName, setPersonName] = React.useState([]);
//   const [charValidation, setCharValidation] = useState({
//     booksAndPublication: false,
//     preferredChapter: false,
//     remarks: false,
//     subjectsAndSession: false,
//   });
//   const ErrorMsg = ({ charLen, name }) => {
//     const isTooLong = charLen > 1800;

//     useEffect(() => {
//       setCharValidation((prev) => ({
//         ...prev,
//         [name]: isTooLong,
//       }));
//     }, [charLen, name, isTooLong]);

//     return (
//       <>
//         {charLen > 1800 ? (
//           <Alert severity="error">Charecter limit exceeded...!</Alert>
//         ) : null}
//       </>
//     );
//   };

//   useEffect(() => {
//     if (personName) {
//       const Opted = {
//         target: {
//           value: personName,
//         },
//       };

//       setData({ ...data, levelOpted: Opted });
//     }
//   }, [personName]);

//   const handleChange = (event) => {
//     const {
//       target: { value },
//     } = event;
//     setPersonName(typeof value === "string" ? value.split(",") : value);
//   };

//   const handleSubmit = () => {
//     const vali = [data].some((item) =>
//       item.booksAndPublication.target.value == "" ||
//       item.subjectsAndSession.target.value == "" ||
//       item.courseLevelStatus.target.value == true
//         ? item.levelOpted.target.value.length == 0
//         : null ||
//           item.preferredChapter.target.value == "" ||
//           item.remarks.target.value == ""
//     );

//     if (!vali) {
//       setOpen(false);
//       handleClose();
//       handleInputChange(data.remarks, item.id, "remarks");
//       handleInputChange(data.levelOpted, item.id, "levelOpted");
//       handleInputChange(data.currentClass, item.id, "currentClass");
//       handleInputChange(data.subjectsAndSession, item.id, "subjectsAndSession");
//       handleInputChange(
//         data.booksAndPublication,
//         item.id,
//         "booksAndPublication"
//       );
//       handleInputChange(data.preferredChapter, item.id, "preferredChapter");
//       enqueueSnackbar("Remarks Added Successfully...!", {
//         variant: "success",
//       });
//     } else {
//       enqueueSnackbar("Please fill all fields ...!", {
//         variant: "error",
//       });
//     }
//   };

//   useEffect(() => {
//     if (item) {
//       const rema = {
//         target: {
//           value: item.remarks,
//         },
//       };
//       const prefChptr = {
//         target: {
//           value: item.projectId !== 1 ? "Nil" : item.preferredChapter,
//         },
//       };
//       const bksAndPub = {
//         target: {
//           value: item.projectId !== 1 ? "Nil" : item.booksAndPublication,
//         },
//       };
//       const lvlOpted = {
//         target: {
//           value: item.levelOpted,
//         },
//       };
//       const currentClass = {
//         target: {
//           value: item.currentClass,
//         },
//       };
//       const subAndSession = {
//         target: {
//           value: item.subjectsAndSession,
//         },
//       };
//       setPersonName(item.levelOpted);
//       setData({
//         ...data,
//         remarks: rema,
//         preferredChapter: prefChptr,
//         booksAndPublication: bksAndPub,
//         levelOpted: lvlOpted,
//         currentClass: currentClass,
//         subjectsAndSession: subAndSession,
//       });
//     }
//   }, [item]);
//   return (
//     <div>
//       <GlobalDialog
//         title={"Remarks"}
//         open={open}
//         setOpen={setOpen}
//         closeButton={true}
//         maxWidth={"sm"}
//         fullWidth
//         popupButton={
//           <LogButton size="small" action={() => setOpen(true)}>
//             {update ? "View Remarks" : paid ? "View Remarks" : "Add Remarks"}
//           </LogButton>
//         }
//         content={
//           <>
//             {open ? (
//               <Box>
//                 <Stack direction={"column"} spacing={2}>
//                   <MotionContainer delay={0.1}>
//                     <FormControl fullWidth>
//                       <InputLabel id={`currentClass`}>Current Class</InputLabel>
//                       <Select
//                         name={`currentClass`}
//                         value={data.currentClass.target.value || ""}
//                         label="Current Class"
//                         onChange={(event) => {
//                           const val = { target: { value: event.target.value } };
//                           setData({ ...data, currentClass: val });
//                         }}
//                       >
//                         {classes.map((item) => (
//                           <MenuItem key={item.classId} value={item.classId}>
//                             {item.className}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </MotionContainer>
//                   <TextField
//                     label="Remarks"
//                     multiline
//                     fullWidth
//                     rows={3}
//                     required
//                     value={data.remarks?.target?.value}
//                     onChange={(e) => {
//                       setData({ ...data, remarks: e });
//                       // setRemarks(e);
//                     }}
//                   />
//                   <ErrorMsg
//                     charLen={data.remarks?.target?.value?.length}
//                     name={"remarks"}
//                   />

//                   {item?.courseLevelStatus ? (
//                     <MotionContainer>
//                       <Box>
//                         <FormControl sx={{ width: "100%" }}>
//                           <InputLabel id="demo-multiple-chip-label">
//                             Level Opted
//                           </InputLabel>
//                           <Select
//                             labelId="demo-multiple-chip-label"
//                             id="demo-multiple-chip"
//                             multiple
//                             value={data.levelOpted.target.value || []}
//                             onChange={handleChange}
//                             input={
//                               <OutlinedInput
//                                 id="select-multiple-chip"
//                                 label="Language Fuency"
//                               />
//                             }
//                             renderValue={(selected) => (
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   flexWrap: "wrap",
//                                   gap: 0.5,
//                                 }}
//                               >
//                                 {selected?.map((value, i) => (
//                                   <Box key={i}>
//                                     <motion.div
//                                       initial={{ opacity: 0, x: -80 }}
//                                       animate={{ opacity: 1, x: 0 }}
//                                       exit={{ opacity: 0, x: -50 }}
//                                       transition={{ duration: 0.4 }}
//                                     >
//                                       <Chip
//                                         size="small"
//                                         // color="primary"
//                                         sx={{
//                                           background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
//                                           color: "white",
//                                         }}
//                                         icon={
//                                           <Icon
//                                             color="white"
//                                             icon="clarity:language-line"
//                                           />
//                                         }
//                                         variant="contained"
//                                         key={value}
//                                         label={value}
//                                       />
//                                     </motion.div>
//                                   </Box>
//                                 ))}
//                               </Box>
//                             )}
//                             MenuProps={MenuProps}
//                           >
//                             {names.map((name) => (
//                               <MenuItem
//                                 key={name}
//                                 value={name}
//                                 //   style={getStyles(name, personName, theme)}
//                               >
//                                 {name}
//                               </MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </Box>
//                     </MotionContainer>
//                   ) : null}
//                   {item.projectId === 1 ? (
//                     <>
//                       <Box>
//                         <TextField
//                           label="Books And Publication"
//                           fullWidth
//                           multiline
//                           rows={3}
//                           value={data.booksAndPublication.target.value}
//                           onChange={(e) => {
//                             setData({ ...data, booksAndPublication: e });
//                           }}
//                         />
//                         <ErrorMsg
//                           charLen={
//                             data.booksAndPublication.target.value?.length
//                           }
//                           name={"booksAndPublication"}
//                         />
//                       </Box>
//                       <Box>
//                         <TextField
//                           label="Preferred Chapter"
//                           fullWidth
//                           multiline
//                           rows={3}
//                           value={data.preferredChapter.target.value}
//                           onChange={(e) => {
//                             setData({ ...data, preferredChapter: e });
//                           }}
//                         />
//                         <ErrorMsg
//                           charLen={data.preferredChapter.target.value?.length}
//                           name={"preferredChapter"}
//                         />
//                       </Box>
//                     </>
//                   ) : null}

//                   <Box>
//                     <TextField
//                       label="Subjects And Session"
//                       fullWidth
//                       multiline
//                       rows={3}
//                       value={data.subjectsAndSession.target.value}
//                       onChange={(e) => {
//                         setData({ ...data, subjectsAndSession: e });
//                       }}
//                     />
//                     <ErrorMsg
//                       charLen={data.subjectsAndSession.target.value?.length}
//                       name={"subjectsAndSession"}
//                     />
//                   </Box>
//                 </Stack>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     padding: 1,
//                   }}
//                 >
//                   <Stack direction={"row"} spacing={1}>
//                     <CancelButton size="small" action={() => setOpen(false)}>
//                       Cancel
//                     </CancelButton>
//                   </Stack>
//                   <SaveButton
//                     type="submit"
//                     size="small"
//                     disabled={
//                       paid ||
//                       charValidation.booksAndPublication ||
//                       charValidation.preferredChapter ||
//                       charValidation.remarks ||
//                       charValidation.subjectsAndSession
//                         ? true
//                         : false
//                     }
//                     action={handleSubmit}
//                   >
//                     Save
//                   </SaveButton>
//                 </Box>
//               </Box>
//             ) : null}
//           </>
//         }
//       />
//     </div>
//   );
// };

// export default RemarkPopup;

import React, { useEffect, useState, useMemo, useCallback } from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { CancelButton, LogButton, SaveButton } from '../../../../components/mui/Buttons/Buttons';
import {
  Alert,
  Autocomplete,
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import MotionContainer from '../../../../components/FramerMotion/MotionContainer';
import { motion } from 'framer-motion';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Icon } from '@iconify/react';
import { useSelector, useDispatch } from 'react-redux';
import { getAvailableBatch } from '../../../../redux/features/cartSlice';
import axios from 'axios';

const ErrorMsg = React.memo(({ charLen }) =>
  charLen > 1800 ? <Alert severity="error">Character limit exceeded...!</Alert> : null
);

const RemarkPopup = ({ item, handleInputChange, handleClose, update, paid }) => {
  const { loading, availableBatchList } = useSelector((state) => state.cart);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  // --------------------------------------------------------------------

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');

  // -----------------------------------------------------------------

  const dispatch = useDispatch();
  const { classes } = useSelector((state) => state.cro);
  const { enqueueSnackbar } = useSnackbar();

  const [open, setOpen] = useState(false);

  const names = useMemo(
    () => ['level 1', 'level 2', 'level 3', 'level 4', 'level 5', 'Basic', 'Intermediate', 'Advanced'],
    []
  );

  const menuProps = useMemo(() => ({ PaperProps: { style: { maxHeight: 48 * 4.5 + 8, width: 250 } } }), []);

  const [data, setData] = useState({
    levelOpted: { target: { value: [] } },
    booksAndPublication: { target: { value: '' } },
    preferredChapter: { target: { value: '' } },
    remarks: { target: { value: '' } },
    courseLevelStatus: { target: { value: item?.courseLevelStatus } },
    currentClass: { target: { value: item?.currentClass || '' } },
    subjectsAndSession: { target: { value: item?.subjectsAndSession || '' } },
    courseBatchId: { target: { value: item?.courseBatchId || '' } },
    // --------------------------------------------------------------
    country: { target: { value: item?.country || '' } },
    state: { target: { value: item?.state || '' } },
    city: { target: { value: item?.city || '' } },
    isRetention: { target: { value: item?.isRetention || '' } },
  });

  // -----------------------------------------------------------
  // Fetch countries (on mount)
  useEffect(() => {
    axios
      .get('https://countriesnow.space/api/v0.1/countries/positions')
      .then((res) => setCountries(res.data.data))
      .catch((err) => console.error(err));
  }, []);

  // Fetch states when country changes
  useEffect(() => {
    if (data.country.target.value) {
      axios
        .post('https://countriesnow.space/api/v0.1/countries/states', {
          country: data.country.target.value,
        })
        .then((res) => setStates(res.data.data.states))
        .catch((err) => console.error(err));
    } else {
      setStates([]);
      setCities([]);
    }
  }, [data.country.target.value]);

  // Fetch cities when state changes
  useEffect(() => {
    if (data.country.target.value && data.state.target.value) {
      axios
        .post('https://countriesnow.space/api/v0.1/countries/state/cities', {
          country: data.country.target.value,
          state: data.state.target.value,
        })
        .then((res) => setCities(res.data.data))
        .catch((err) => console.error(err));
    } else {
      setCities([]);
    }
  }, [data.state.target.value]);
  // ----------------------------------------------------------

  useEffect(() => {
    if (open && item.batchAvailability === 1) dispatch(getAvailableBatch(item.id));
  }, [open, item.id, dispatch]);

  useEffect(() => {
    if (item) {
      setData({
        levelOpted: { target: { value: item.levelOpted || [] } },
        booksAndPublication: {
          target: {
            value: item.projectId !== 1 ? 'Nil' : item.booksAndPublication || '',
          },
        },
        preferredChapter: {
          target: {
            value: item.projectId !== 1 ? 'Nil' : item.preferredChapter || '',
          },
        },
        remarks: { target: { value: item.remarks || '' } },
        courseLevelStatus: { target: { value: item.courseLevelStatus } },
        currentClass: { target: { value: item.currentClass || '' } },
        subjectsAndSession: {
          target: { value: item.subjectsAndSession || '' },
        },
        courseBatchId: { target: { value: item?.courseBatchId || '' } },
        // -----------------------------------------------------------------
        country: { target: { value: item?.country || '' } },
        state: { target: { value: item?.state || '' } },
        city: { target: { value: item?.city || '' } },
        isRetention: { target: { value: item?.isRetention || 0 } },
      });
    }
  }, [item]);

  const handleFieldChange = useCallback((field, value) => {
    setData((prev) => ({ ...prev, [field]: { target: { value } } }));
  }, []);

  const handleSubmit = () => {
    const d = data;
    const isInvalid =
      !d.booksAndPublication.target.value ||
      !d.subjectsAndSession.target.value ||
      // (d.courseLevelStatus.target.value &&
      //   d.levelOpted.target.value.length === 0) ||
      !d.preferredChapter.target.value ||
      !d.remarks.target.value ||
      (item.batchAvailability === 1 && !d.courseBatchId.target.value);
    //  ||
    // !d.country.target.value ||
    // !d.state.target.value ||
    // !d.city.target.value;

    if (isInvalid) {
      enqueueSnackbar('Please fill all fields ...!', { variant: 'error' });
      return;
    }

    setOpen(false);
    handleClose();
    Object.entries(d).forEach(([key, val]) => {
      handleInputChange(val, item.id, key);
    });

    enqueueSnackbar('Remarks Added Successfully...!', { variant: 'success' });
  };

  const charValidation = useMemo(
    () => ({
      booksAndPublication: data.booksAndPublication.target.value.length > 1800,
      preferredChapter: data.preferredChapter.target.value.length > 1800,
      remarks: data.remarks.target.value.length > 1800,
      subjectsAndSession: data.subjectsAndSession.target.value.length > 1800,
    }),
    [data]
  );

  return (
    <GlobalDialog
      title="Remarks"
      open={open}
      setOpen={setOpen}
      closeButton
      maxWidth="sm"
      fullWidth
      popupButton={
        <LogButton size="small" action={() => setOpen(true)}>
          {update || paid ? 'View Remarks' : 'Add Remarks'}
        </LogButton>
      }
      content={
        open && (
          <Box>
            {/* ---------------------------batch---------------------------- */}
            {item.batchAvailability === 1 ? (
              <Stack direction={'column'} sx={{ mb: 2 }}>
                <Autocomplete
                  options={availableBatchList}
                  getOptionLabel={(option) => option.display || ''}
                  value={
                    availableBatchList.find((item) => item.courseBatchID === data.courseBatchId.target.value) || null
                  }
                  onChange={(event, newValue) => {
                    handleFieldChange('courseBatchId', newValue ? newValue.courseBatchID : null);
                    // setSelectedBatchId(
                    //   newValue ? newValue.courseBatchID : null
                    // );
                  }}
                  renderInput={(params) => <TextField {...params} label="Select Course Batch" variant="outlined" />}
                />
              </Stack>
            ) : null}

            {/* ---------------------------------------------------- */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
              {/* Country Dropdown */}
              {/* <FormControl sx={{ minWidth: 200 }}>
                <InputLabel>Country</InputLabel>
                <Select
                  value={data.country.target.value}
                  label="Country"
                  onChange={(e) => {
                    handleFieldChange('country', e.target.value);
                    setSelectedCountry(e.target.value);
                    setSelectedState('');
                    setSelectedCity('');
                  }}
                >
                  {countries.map((c) => (
                    <MenuItem key={c.name} value={c.name}>
                      {c.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

              {/* State Dropdown */}
              {/* <FormControl sx={{ minWidth: 200 }} disabled={!states.length}>
                <InputLabel>State</InputLabel>
                <Select
                  value={data.state.target.value}
                  label="State"
                  onChange={(e) => {
                    handleFieldChange('state', e.target.value);
                    setSelectedState(e.target.value);
                    setSelectedCity('');
                  }}
                >
                  {states.map((s) => (
                    <MenuItem key={s.name} value={s.name}>
                      {s.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

              {/* City Dropdown */}
              {/* <FormControl sx={{ minWidth: 200 }} disabled={!cities.length}>
                <InputLabel>City</InputLabel>
                <Select
                  value={data.city.target.value}
                  label="City"
                  onChange={(e) => {
                    handleFieldChange('city', e.target.value);
                    setSelectedCity(e.target.value);
                  }}
                >
                  {cities.map((city) => (
                    <MenuItem key={city} value={city}>
                      {city}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </Box>
            {/* -------------------------------------------------------------- */}

            <Stack direction="column" spacing={2}>
              <MotionContainer delay={0.1}>
                <FormControl fullWidth>
                  <InputLabel>Current Class</InputLabel>
                  <Select
                    label="Current Class"
                    value={data.currentClass.target.value}
                    onChange={(e) => handleFieldChange('currentClass', e.target.value)}
                  >
                    {classes.map((cls) => (
                      <MenuItem key={cls.classId} value={cls.classId}>
                        {cls.className}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MotionContainer>
              {/* --------------------------------------- */}

              <MotionContainer delay={0.1}>
                <FormControl fullWidth>
                  <InputLabel>Retention Status</InputLabel>
                  <Select
                    label="Retention Status"
                    value={data.isRetention.target.value}
                    onChange={(e) => handleFieldChange('isRetention', e.target.value)}
                  >
                    {[
                      { id: 0, name: 'No Retention' },
                      { id: 1, name: 'Up Sell' },
                      { id: 2, name: 'Cross Sell' },
                    ].map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MotionContainer>

              <TextField
                label="Remarks"
                multiline
                fullWidth
                rows={3}
                value={data.remarks.target.value}
                onChange={(e) => handleFieldChange('remarks', e.target.value)}
              />
              <ErrorMsg charLen={data.remarks.target.value.length} />

              {item?.courseLevelStatus && (
                <MotionContainer>
                  <FormControl fullWidth>
                    <InputLabel>Level Opted</InputLabel>
                    <Select
                      multiple
                      value={data.levelOpted.target.value}
                      onChange={(e) =>
                        handleFieldChange(
                          'levelOpted',
                          typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value
                        )
                      }
                      input={<OutlinedInput label="Level Opted" />}
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map((val, i) => (
                            <motion.div
                              key={i}
                              initial={{ opacity: 0, x: -80 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ duration: 0.4 }}
                            >
                              <Chip
                                size="small"
                                sx={{
                                  background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                                  color: 'white',
                                }}
                                icon={<Icon color="white" icon="clarity:language-line" />}
                                label={val}
                              />
                            </motion.div>
                          ))}
                        </Box>
                      )}
                      MenuProps={menuProps}
                    >
                      {names.map((name) => (
                        <MenuItem key={name} value={name}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </MotionContainer>
              )}

              {item.projectId === 1 && (
                <>
                  <TextField
                    label="Books And Publication"
                    multiline
                    fullWidth
                    rows={3}
                    value={data.booksAndPublication.target.value}
                    onChange={(e) => handleFieldChange('booksAndPublication', e.target.value)}
                  />
                  <ErrorMsg charLen={data.booksAndPublication.target.value.length} />

                  <TextField
                    label="Preferred Chapter"
                    multiline
                    fullWidth
                    rows={3}
                    value={data.preferredChapter.target.value}
                    onChange={(e) => handleFieldChange('preferredChapter', e.target.value)}
                  />
                  <ErrorMsg charLen={data.preferredChapter.target.value.length} />
                </>
              )}

              <TextField
                label="Subjects And Session"
                multiline
                fullWidth
                rows={3}
                value={data.subjectsAndSession.target.value}
                onChange={(e) => handleFieldChange('subjectsAndSession', e.target.value)}
              />
              <ErrorMsg charLen={data.subjectsAndSession.target.value.length} />
            </Stack>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 1 }}>
              <Stack direction="row" spacing={1}>
                <CancelButton size="small" action={() => setOpen(false)}>
                  Cancel
                </CancelButton>
              </Stack>
              <SaveButton
                size="small"
                disabled={paid || Object.values(charValidation).some(Boolean)}
                action={handleSubmit}
              >
                Save
              </SaveButton>
            </Box>
          </Box>
        )
      }
    />
  );
};

export default RemarkPopup;
